import { RiskProfileCheck } from '../wallet-ow';
import { Column } from '../../column';
import walletErDetailMessages from '../../../messages/wallet/wallet-er-detail.messages';

export const riskProfileErColumns: Column<RiskProfileCheck>[] = [
  {
    headerLabel: walletErDetailMessages.riskProfileParameterNameColumn,
    key: 'type',
    type: 'string',
  },
  {
    headerLabel: walletErDetailMessages.riskProfileParameterDescriptionColumn,
    key: 'description',
    type: 'string',
  },
  {
    headerLabel: walletErDetailMessages.riskProfileValueColumn,
    key: 'value',
    type: 'percentage',
  },
  {
    headerLabel: walletErDetailMessages.riskProfileThresholdColumn,
    key: 'thresholdValue',
    type: 'percentage',
  },
  {
    headerLabel: walletErDetailMessages.riskProfileResultColumn,
    key: 'isLimitRespected',
    type: 'string',
  },
];
